var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "44px",
    viewBox: "0 0 39 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---Purple",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---2---Dropdowns",
    transform: "translate(-115.000000, -13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NAV"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Logo",
    transform: "translate(112.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KH-logo-Copy",
    transform: "translate(3.300000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-1",
    fill: "#FFFFFE",
    points: "6.33777778 14.7288889 6.33777778 29.3644444 19.0133333 36.68 19.0133333 43.9995556 0 33.0222222 0 11.0711111 6.33777778 14.7288889"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-2",
    fill: "#FFFFFE",
    points: "19.0133333 7.41333333 19.0133333 22.0488889 31.6888889 14.7288889 19.0133333 7.41333333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    fill: "#EDD7C1"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-16",
    points: "31.6888889 7.41333333 25.3511111 3.75111111 19.0133333 0.0933333333 14.1911111 2.87555556 6.33777778 7.41333333 6.33777778 7.40888889 0 11.0711111 6.33777778 14.7288889 11.5244444 11.7333333 12.6755556 11.0711111 19.0133333 7.41333333 31.6888889 14.7288889 38.0222222 11.0711111 31.6888889 7.41333333"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-18",
    fill: "#6CC5D9",
    points: "25.3511111 18.3866667 25.3511111 25.7066667 24.0088889 26.48 19.0133333 29.3644444 12.6755556 25.7066667 12.6755556 18.3866667 19.0133333 14.7288889 19.0133333 7.41333333 13.9288889 10.3466667 10.2666667 12.4622222 6.33777778 14.7288889 6.33777778 29.3644444 19.0133333 36.68 31.6888889 29.3644444 31.6888889 14.7288889 25.3511111 18.3866667"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-19",
    fill: "#90705A",
    points: "31.6888889 14.7288889 31.6888889 29.3644444 19.0133333 36.68 19.0133333 43.9995556 38.0222222 33.0222222 38.0222222 11.0711111 31.6888889 14.7288889"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-20",
    fill: "#0A0B09",
    points: "19.0133333 22.0488889 19.0133333 14.7288889 12.6755556 18.3866667 12.6755556 25.7066667 19.0133333 29.3644444 24.0088889 26.48 25.3511111 25.7066667 25.3511111 18.3866667 19.0133333 22.0488889"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/header-logo.1886423caaec02e647d6433eb2b14a8b.svg";
export { ForwardRef as ReactComponent };